import EventsTemplate from "components/templates/EventsTemplate/EventsTemplate";

const EventsPage = () => {
  return <EventsTemplate />;
};

export default EventsPage;
